export const AVATAR_URL_MAX_LENGTH = 2048;

export function normalizeAvatarUrl(value: string | null | undefined): string {
  return (value ?? "").trim();
}

export function isUsingGoogleAvatar(
  avatarUrl: string | null | undefined,
  googleAvatarUrl: string | null | undefined,
): boolean {
  const google = normalizeAvatarUrl(googleAvatarUrl);
  if (!google) return false;
  const current = normalizeAvatarUrl(avatarUrl);
  return current === google;
}

export function isAvatarOverride(
  avatarUrl: string | null | undefined,
  googleAvatarUrl: string | null | undefined,
): boolean {
  const google = normalizeAvatarUrl(googleAvatarUrl);
  if (!google) return false;
  const current = normalizeAvatarUrl(avatarUrl);
  return current !== "" && current !== google;
}

export function isValidAvatarUrl(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) return true;
  if (trimmed.length > AVATAR_URL_MAX_LENGTH) return false;
  try {
    const url = new URL(trimmed);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}
